
(() => {
  // Cache DOM elements
  const frames = [...document.querySelectorAll("[data-zoom]")];
  const pullQuotes = [...document.querySelectorAll("[data-qfill]")];

  // Optional progress bar
  const bar = document.querySelector(".progress-bar");

  // Set transform origin from data-origin
  frames.forEach((frame) => {
    const img = frame.querySelector("img");
    const origin = frame.getAttribute("data-origin");

    if (img && origin) {
      img.style.transformOrigin = origin;
    }
  });

  function update() {
    const vh = window.innerHeight;

    /* -------------------------------
       Progress Bar
    -------------------------------- */
    if (bar) {
      const scrollHeight =
        document.documentElement.scrollHeight - vh;

      const progress =
        scrollHeight > 0
          ? (window.scrollY / scrollHeight) * 100
          : 0;

      bar.style.width = `${progress}%`;
    }

    /* -------------------------------
       Image Zoom
    -------------------------------- */
    frames.forEach((frame) => {
      const img = frame.querySelector("img");
      if (!img) return;

      const rect = frame.getBoundingClientRect();

      // Skip if outside viewport
      if (rect.bottom < 0 || rect.top > vh) return;

      // Progress:
      // 0 when entering from bottom
      // 1 when exiting through top
      const progress =
        (rect.top + rect.height / 2 - vh / 2) /
        (vh / 2 + rect.height / 2);

      let zoomProgress = (1 - progress) / 2;

      zoomProgress = Math.max(0, Math.min(zoomProgress, 1));

      const amount =
        (parseFloat(frame.getAttribute("data-zoom")) || 15) / 100;

      const scale =
        1 + amount * zoomProgress;

      img.style.transform =
        `scale(${scale.toFixed(4)})`;
    });

    /* -------------------------------
       Pull Quote Fill
    -------------------------------- */
    pullQuotes.forEach((quote) => {
      const fill = quote.querySelector(".qfill");
      if (!fill) return;

      const rect = quote.getBoundingClientRect();

      const start = vh * 0.88;
      const end = vh * 0.42;

      let progress =
        (start - rect.top) / (start - end);

      progress = Math.max(0, Math.min(progress, 1));

      const minWidth = 5;

      fill.style.width =
        `${minWidth + progress * (quote.offsetWidth - minWidth)}px`;

      quote.classList.toggle(
        "filled",
        progress > 0.6
      );
    });
  }

  // requestAnimationFrame throttle
  let ticking = false;

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(() => {
        update();
        ticking = false;
      });

      ticking = true;
    }
  }

  window.addEventListener("scroll", onScroll, {
    passive: true
  });

  window.addEventListener("resize", update);

  // Initial run
  update();
})();

(() => {
  // Magazine landing page: hamburger lives in the fixed bottom bar and
  // toggles the issue-toc as a full overlay drawer (with backdrop) instead
  // of the in-article panel handled below.
  const bottomBar = document.getElementById("mag-bottom-bar");
  const overlay = document.getElementById("mag-drawer-overlay");
  const overlayDrawer = document.getElementById("mag-drawer");

  if (bottomBar && overlay && overlayDrawer) {
    const btn = bottomBar.querySelector(".ham");
    const header = document.querySelector(".site-header, header.site-header");

    if (!btn) return;

    function positionDrawer() {
      let top = 0;
      if (header) {
        const r = header.getBoundingClientRect();
        top = Math.max(0, r.bottom);
      }
      overlayDrawer.style.top = top + "px";
      overlay.style.top = top + "px";
    }

    function open() {
      positionDrawer();
      overlayDrawer.classList.add("is-open");
      overlay.classList.add("is-open");
      bottomBar.classList.add("is-open");
      btn.classList.add("active");
      btn.setAttribute("aria-expanded", "true");
      overlayDrawer.setAttribute("aria-hidden", "false");
    }

    function close() {
      overlayDrawer.classList.remove("is-open");
      overlay.classList.remove("is-open");
      bottomBar.classList.remove("is-open");
      btn.classList.remove("active");
      btn.setAttribute("aria-expanded", "false");
      overlayDrawer.setAttribute("aria-hidden", "true");
    }

    btn.addEventListener("click", () => {
      (overlayDrawer.classList.contains("is-open") ? close : open)();
    });

    overlay.addEventListener("click", close);

    // Anywhere in the drawer outside the toc list (e.g. the issue-toc-cover
    // image) closes it too; clicks inside issue-toc-list are left alone so
    // its links still navigate.
    overlayDrawer.addEventListener("click", (e) => {
      if (!e.target.closest(".issue-toc-list")) close();
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && overlayDrawer.classList.contains("is-open")) close();
    });

    window.addEventListener("resize", () => {
      if (overlayDrawer.classList.contains("is-open")) positionDrawer();
    });

    window.addEventListener("scroll", () => {
      if (overlayDrawer.classList.contains("is-open")) positionDrawer();
    }, { passive: true });

    return;
  }

  const hamburger = document.querySelector(".ham");
  const articleContainer = document.querySelector(".article-body > .container");
  const issueToc = document.querySelector(".issue-toc");
  const pa = document.querySelector(".issue-toc-cover");
  const articleSection = issueToc ? issueToc.closest(".article-body") : null;

  if (!hamburger || !articleContainer || !issueToc || !articleSection) return;

  function setOpen(isOpen) {
    issueToc.classList.toggle("is-open", isOpen);
    hamburger.classList.toggle("active", isOpen);
    articleContainer.classList.toggle("is-hidden", isOpen);
    articleSection.classList.toggle("toc-open", isOpen);

    const siteHeader = document.querySelector(".site-header");
    const stickyBar = document.querySelector(".sticky-bar");
    const fixedOffset =
      (siteHeader ? siteHeader.offsetHeight : 0) +
      (stickyBar ? stickyBar.offsetHeight : 0);

    const top =
      articleSection.getBoundingClientRect().top + window.scrollY - fixedOffset;

    window.scrollTo({ top, behavior: "smooth" });
  }

  hamburger.addEventListener("click", () => {
    setOpen(!issueToc.classList.contains("is-open"));
  });

  if (issueTocCover) {
    issueTocCover.addEventListener("click", () => {
      if (issueToc.classList.contains("is-open")) {
        setOpen(false);
      }
    });
  }
})();